import { Link } from 'react-router-dom';

import './SideMenu.css'

function SideMenu ({ isSideMenuOpen, toggleSideMenu }) {
    return (
    <div className = {`side-menu ${isSideMenuOpen ? 'side-menu--open' : ''}`}>
        <button className="close-btn" onClick={toggleSideMenu}>
          ✖
        </button>
        <div className="side-menu--nav">
          <h2>Menu</h2>
          <div className='side-menu--icons'>
            <Link to="/cart" onClick={toggleSideMenu}>
              <img src={`${process.env.PUBLIC_URL}/cart.png`} alt="Cart Icon" className="side-menu--icon" />
            </Link>
            <Link to="/mypage" onClick={toggleSideMenu}>
              <img src={`${process.env.PUBLIC_URL}/my.png`} alt="My Icon" className="side-menu--icon" />
            </Link>
          </div>
        </div>
        <ul>
          <li>
            <Link to="/" onClick={toggleSideMenu}>Home</Link>
          </li>
          <li>
            <Link to="/shop" onClick={toggleSideMenu}>Shop</Link>
          </li>
          <li>
            <Link to="/about" onClick={toggleSideMenu}>About</Link>
          </li>
          <li>
            <Link to="/sell" onClick={toggleSideMenu}>Sell Gears</Link>
          </li>
          <li>
            <Link to="/contact" onClick={toggleSideMenu}>Contact</Link>
          </li>
        </ul>
    </div >
    )
}

export default SideMenu;